import { render, staticRenderFns } from "./guessLike.vue?vue&type=template&id=cb61e6ce&scoped=true&"
import script from "./guessLike.vue?vue&type=script&lang=js&"
export * from "./guessLike.vue?vue&type=script&lang=js&"
import style0 from "./guessLike.vue?vue&type=style&index=0&id=cb61e6ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb61e6ce",
  null
  
)

export default component.exports